import React, { Fragment } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const borderColor = "#90e5fc";
const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    borderBottomColor: "#bff0fd",
    borderBottomWidth: 1,
    minHeight: 30,
    flexGrow: 1,
    fontSize: "9px",
    alignItems: "center",
  },
  date: {
    width: "10%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "center",
  },
  transaction: {
    width: "12%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "center",
  },
  description: {
    width: "20%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "center",
    // maxWidth: 100,
  },
  payment: {
    width: "10%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "center",
  },
  creditBalance: {
    width: "10%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "center",
  },
  outstanding: {
    width: "10%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "center",
  },
  qty: {
    width: "6%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "center",
    marginRight: 10,
  },
  balance_qty: {
    width: "10%",
    textAlign: "center",
    marginRight: 10,
  },
});
export class AccountMainTableRow extends React.Component {
  render() {
    let { items } = this.props;
    return items.map((item, index) => (
      <View style={styles.row} key={index}>
        <Text style={styles.date}>{item.sa_date}</Text>
        <Text style={styles.transaction}>{item.transaction}</Text>
        {/*<Text style={styles.transaction}>{item.treatment_parentcode}</Text>*/}
        <Text style={styles.description}>{item.description}</Text>
        {/*<Text style={styles.payment}>{item.payment}</Text>*/}
        {/*<Text style={styles.creditBalance}>{item.balance}</Text>*/}
        {/*<Text style={styles.outstanding}>{item.outstanding}</Text>*/}
        {/*<Text style={styles.qty}>{item.qty}</Text>*/}
        <Text style={styles.balance_qty}>{item.balance_qty}</Text>
      </View>
    ));
  }
}
